/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CharCriteriaResponse
 */
export interface CharCriteriaResponse {
    /**
     * 
     * @type {string}
     * @memberof CharCriteriaResponse
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CharCriteriaResponse
     */
    exclude?: boolean;
}

export function CharCriteriaResponseFromJSON(json: any): CharCriteriaResponse {
    return CharCriteriaResponseFromJSONTyped(json, false);
}

export function CharCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharCriteriaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function CharCriteriaResponseToJSON(value?: CharCriteriaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'exclude': value.exclude,
    };
}


